import MobayiloAuthPanel from "../../packages/mobayilo-auth-panel/src/index.js"

if (window.customElements && !window.customElements.get("mobayilo-auth-panel")) {
  window.customElements.define("mobayilo-auth-panel", MobayiloAuthPanel)
}

const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || ""

const parseErrorMessage = async (response) => {
  try {
    const data = await response.json()
    if (typeof data?.error === "string" && data.error.length > 0) return data.error
  } catch (_error) {
    // Fall back to a generic message when response is not JSON.
  }

  return "Request failed. Please try again."
}

const postForm = async (url, payload) => {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      "X-CSRF-Token": csrfToken()
    },
    body: new URLSearchParams(payload),
    credentials: "same-origin"
  })

  if (!response.ok) {
    const error = await parseErrorMessage(response)
    throw new Error(error)
  }

  return response.json()
}

const postRedirect = (url) => {
  const form = document.createElement("form")
  form.method = "post"
  form.action = url
  form.style.display = "none"

  const token = document.createElement("input")
  token.type = "hidden"
  token.name = "authenticity_token"
  token.value = csrfToken()

  form.appendChild(token)
  document.body.appendChild(form)
  form.submit()
}

const wireAuthPanel = (panel) => {
  if (!panel || panel.dataset.authBound === "true") return
  panel.dataset.authBound = "true"

  const sessionUrl = panel.getAttribute("session-url") || "/users/sign_in"
  const verifyUrl = panel.getAttribute("verify-url") || "/users/sign_in/verify_code"

  panel.addEventListener("auth-panel:submit", async (event) => {
    event.preventDefault()

    const { email } = event.detail
    panel.showLoading("Sending verification code...")

    try {
      const payload = await postForm(sessionUrl, { email })
      panel.setSessionId(payload.session_id)
      panel.showSuccess(payload.email || email)
    } catch (error) {
      panel.showError(error.message)
    }
  })

  panel.addEventListener("auth-panel:resend", async (event) => {
    event.preventDefault()

    const { email } = event.detail
    panel.setSuccessStatus("Sending new code...", "info")

    try {
      const payload = await postForm(sessionUrl, { email })
      panel.setSessionId(payload.session_id)
      panel.resendSuccess("Verification code sent again.")
    } catch (error) {
      panel.setSuccessStatus(error.message, "error")
    }
  })

  panel.addEventListener("auth-panel:verify", async (event) => {
    event.preventDefault()

    const { email, code, sessionId } = event.detail
    panel.setSuccessStatus("Verifying code...", "info")

    try {
      const payload = await postForm(verifyUrl, {
        email,
        code,
        session_id: sessionId || panel.getSessionId()
      })

      const redirectTo = payload.redirect_to
      if (typeof redirectTo === "string" && redirectTo.length > 0) {
        window.location.assign(redirectTo)
        return
      }

      panel.setSuccessStatus("Signed in.", "info")
    } catch (error) {
      panel.setSuccessStatus(error.message, "error")
    }
  })

  panel.addEventListener("auth-panel:google", (event) => {
    event.preventDefault()
    const googleUrl = panel.getAttribute("google-url")
    if (googleUrl) postRedirect(googleUrl)
  })

  panel.addEventListener("auth-panel:facebook", (event) => {
    event.preventDefault()
    const facebookUrl = panel.getAttribute("facebook-url")
    if (facebookUrl) postRedirect(facebookUrl)
  })

  panel.addEventListener("auth-panel:x", (event) => {
    event.preventDefault()
    const xUrl = panel.getAttribute("x-url")
    if (xUrl) postRedirect(xUrl)
  })
}

const initializeMobayiloAuthPanels = () => {
  document.querySelectorAll('mobayilo-auth-panel[data-auth-stack="true"]').forEach(wireAuthPanel)
}

document.addEventListener("DOMContentLoaded", initializeMobayiloAuthPanels)
document.addEventListener("turbo:load", initializeMobayiloAuthPanels)
